import { createSelector } from 'reselect'
import {
  ReportDownloadListModel,
  ReportDownloadListResponse,
} from 'src/models/reportDownload.models'
import { RootState } from 'src/redux/createRootReducer'

export const selectReportDownloadListResponsesFromState = (
  state: RootState,
): Record<string, ReportDownloadListResponse> =>
  state.data.reportDownloads.listResponses

export const selectReportDownloadListModelsFromState = createSelector(
  [selectReportDownloadListResponsesFromState],
  (reportDownloadListResponses) =>
    Object.values(reportDownloadListResponses).reduce(
      (acc, curr) => ({
        ...acc,
        [curr.id]: new ReportDownloadListModel(curr),
      }),
      {},
    ),
)

export const selectReportDownloadLoadingFromState = (
  state: RootState,
): boolean => state.data.reportDownloads.loading

export const selectTopLevelErrorFromState = (
  state: RootState,
): string | undefined => state.data.reportDownloads.topLevelError
